import React, { createContext, useState } from 'react';
import Vuotlink from './home';

// Tạo MyContext
export const MyContext = createContext();

const Indexok = ({ children }) => {
    // Sử dụng useState để quản lý giá trị state
    const [show_check_done, setshow_check_done] = useState(false);
    const [caption, setcaption] = useState('');
    const [show_link_done, setshow_link_done] = useState(false);
    const [step_service, setstep_service] = useState(false);
    const [link_done, setlink_done] = useState(false);
    const [money_link, setmoney_link] = useState(false);
    const [remix_lists, set_remix_lists] = useState(false);
    return (
        <MyContext.Provider value={{
            show_check_done, setshow_check_done, caption, setcaption,
            show_link_done, setshow_link_done, step_service, setstep_service,
            link_done, setlink_done, money_link, setmoney_link, remix_lists, set_remix_lists
        }}>
            {children}
        </MyContext.Provider>
    );
};


const App = () => {
    return (
        <Indexok>
            <Vuotlink />
        </Indexok>
    );
};

export default App;